import * as React from 'react';

import * as styles from './breadCrumbs.module.scss';

interface BreadCrumbsProps {
  slug: string;
  title: string;
}

const BreadCrumbs = ({slug, title}: BreadCrumbsProps) => {
  const pathArray = slug.split('/');
  const filterPath = pathArray.filter((el: string) => el !== '');

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <ul className={styles.list}>
          {filterPath.map((url: string, i: number) => {
            const urlTitle = url.replace(/-/g, ' ');
            const segments = filterPath.slice(0, i + 1);
            const urlPath = segments.join('/');
            if (url === 'es') {
              return;
            }
            return (
              <li key={i} className={styles.listItem}>
                {i === filterPath.length - 1 ? (
                  title
                ) : (
                  <a className={styles.link} href={`/${urlPath}/`}>
                    {urlTitle}
                  </a>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default BreadCrumbs;
